<div class="relative">
	<file-pond
		*ngIf="flg_config"
		#myPond
		[options]="pondOptions"
		[files]="pondFiles"
		(onaddfile)="pondHandleAddFile($event)"
		(onremovefile)="pondHandleRemoveFile($event)"
		(oninit)="pondHandleInit()"
		class="z-10"
		[ngClass]="[class]"
	>
	</file-pond>

	<div class="flex justify-center">
		<div class="w-[448px] h-[176px] mx-auto absolute top-0 flex justify-center">
			<mat-icon class="w-[40px] h-[47.99px] min-w-[40px] min-h-[47.99px] mt-12" [svgIcon]="icon"> </mat-icon>
		</div>
	</div>
</div>
<!-- <file-pond *ngIf="flg_config" #myPond [options]="pondOptions" [files]="pondFiles" (oninit)="pondHandleInit()"
    (onaddfile)="pondHandleAddFile($event)" (onremovefile)="pondHandleRemoveFile($event)">
</file-pond> -->
